import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueLogger from "vuejs-logger";
import App from "./App.vue";
import router from "./router";
import formValidator from "./mixins/form-validator";
import store from "./store";
import config from "./config";
import pixels from "./pixels";
import MQ from "vue-match-media/src";
import HTMLSanitize from "./plugins/html-sanitize";
import AdobeLaunch from "./plugins/adobe-launch";
import ABTesting from "./plugins/ab-testing";
import SdkVeridas from "./plugins/sdk-veridas";

// Configuración del módulo
Vue.use(config);

// Vue Logger
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: PRODUCTION ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
});

// Adobe Launch
Vue.use(AdobeLaunch);

// Vue-match-media
Vue.use(MQ);

if (window.__PRERENDER_INJECTED === undefined) {
  /**
   * Omitimos los plugins si estamos corriendo en puppeteer
   * Así evitamos contaminar el HTML pre-renderizado
   */
  Vue.use(pixels);
  Vue.use(ABTesting);
  Vue.use(HTMLSanitize);
  Vue.use(SdkVeridas);
}
if (
  config.get() &&
  config.get().googleAnalyticsId &&
  !config.get().googleGTMId
) {
  Vue.use(VueAnalytics, {
    id: config.get().googleAnalyticsId,
    router,
    autoTracking: {
      exception: true,
      pageviewOnLoad: false
    }
  });
}

/**
 * Instanciar la app luego de obtener y
 * aplicar la configuración del módulo
 */
config.start(() => {
  // Inicializar la app
  const BBVA_APP = new Vue({
    router,
    store,
    mixins: [formValidator],
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
    mq: {
      medium: "(max-width: 1060px) and (min-width: 600px)",
      small: "(min-width: 600px)"
    }
  }).$mount("#app");

  // Agregar timestamp de versionado si existe
  let app_version = _BBVA_VERSION || null;
  if (app_version) {
    BBVA_APP.version = app_version;
  }

  // Exponemos la instancia al scope global
  // Útil para hacer modificaciones desde afuera
  window.BBVA_APP = BBVA_APP;
  return BBVA_APP;
});
